import { atom, selector } from 'recoil';
import { Users, GetMenuDtoRx } from '@/sdk/data-contracts';

export const userInforRecoil = atom<GetMenuDtoRx | null>({
  key: 'userInforRecoil',
  default: null,
});

export const userListRecoil = atom<Users[]>({
  key: 'userListRecoil',
  default: [],
});

export const userTypesRecoil = atom<string[]>({
  key: 'userTypesRecoil',
  default: [],
});

export const userSitesRecoil = atom<string[]>({
  key: 'userSitesRecoil',
  default: [],
});

// export const eventDetailRecoil = atom<GetDetailSiteDtoRx | null>({
//   key: 'eventDetailRecoil',
//   default: null,
// });

// export const eventDetailIdRecoil = atom<number | null>({
//   key: 'eventDetailIdRecoil',
//   default: null,
// });
